// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PmHUq","controls":"styles_controls__tIybR","charLimit":"styles_charLimit__3wPtb","input":"styles_input__blU47","send":"styles_send__LlZSd"};